import type { ReportTemplate } from '../../schemas';

export const VERIFICHE_SECTIONS_PRIMARY: ReportTemplate['sections'] = [
  {
    id: 'sec_verifica-impianto-refrigerazione-ind',
    name: 'Verifica impianto refrigerazione industriale',
    type: 'static',
    fields: [
      {
        id: 'fld_fughe-all-atto-del-sopralluogo',
        label: "Fughe all'atto del sopralluogo",
        type: 'choice',
        options: [
          {
            value: 'si',
            label: 'Sì',
          },
          {
            value: 'no',
            label: 'No',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: "Fughe all'atto del sopralluogo",
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_fughe-segnalate-nel-periodo',
        label: 'Fughe segnalate nel periodo',
        type: 'choice',
        options: [
          {
            value: 'si',
            label: 'Sì',
          },
          {
            value: 'no',
            label: 'No',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Fughe segnalate nel periodo',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_infortuni-dovuti-a-fuga',
        label: 'Infortuni dovuti a fuga',
        type: 'choice',
        options: [
          {
            value: 'si',
            label: 'Sì',
          },
          {
            value: 'no',
            label: 'No',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Infortuni dovuti a fuga',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_dichiarate-dal-personale-patentato',
        label: 'Dichiarate dal personale patentato',
        type: 'choice',
        options: [
          {
            value: 'si',
            label: 'Sì',
          },
          {
            value: 'no',
            label: 'No',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Dichiarate dal personale patentato',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_dichiarate-da-societa-esterna',
        label: 'Dichiarate da società esterna',
        type: 'choice',
        options: [
          {
            value: 'si',
            label: 'Sì',
          },
          {
            value: 'no',
            label: 'No',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Dichiarate da società esterna',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_rilevate-da-sistemi-di-allarme',
        label: 'Rilevate da sistemi di allarme',
        type: 'choice',
        options: [
          {
            value: 'si',
            label: 'Sì',
          },
          {
            value: 'no',
            label: 'No',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Rilevate da sistemi di allarme',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_stato-risoluzione',
        label: 'Stato risoluzione',
        type: 'choice',
        options: [
          {
            value: 'risolto',
            label: 'Risolto',
          },
          {
            value: 'non_risolto',
            label: 'Non risolto',
          },
          {
            value: 'in_corso',
            label: 'In corso',
          },
          {
            value: 'n_a',
            label: 'N/A',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Stato risoluzione',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_dettagli-segnalazioni',
        label: 'Dettagli segnalazioni',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        placeholder: 'Annota eventuali dichiarazioni, tempi di intervento e soggetti coinvolti',
        _idHistory: {
          derivedFrom: 'Dettagli segnalazioni',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_pressione-condensazione',
        label: 'Pressione condensazione',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Pressione condensazione',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_temperatura-olio',
        label: 'Temperatura olio',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Temperatura olio',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_note-parametri',
        label: 'Note parametri',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        placeholder: 'Es. Valori letti e strumenti utilizzati',
        _idHistory: {
          derivedFrom: 'Note parametri',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_stato-manutenzione-ordinaria',
        label: 'Stato manutenzione ordinaria',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Stato manutenzione ordinaria',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_note-manutenzione-ordinaria',
        label: 'Note manutenzione ordinaria',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        placeholder: 'Es. interventi registrati, manutentore, scadenze',
        _idHistory: {
          derivedFrom: 'Note manutenzione ordinaria',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_effettuate-nel-periodo',
        label: 'Effettuate nel periodo',
        type: 'choice',
        options: [
          {
            value: 'si',
            label: 'Sì',
          },
          {
            value: 'no',
            label: 'No',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Effettuate nel periodo',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_straordinarie-dichiarate-dal-persona',
        label: 'Straordinarie dichiarate dal personale patentato',
        type: 'choice',
        options: [
          {
            value: 'si',
            label: 'Sì',
          },
          {
            value: 'no',
            label: 'No',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Straordinarie dichiarate dal personale patentato',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_straordinarie-dichiarate-da-societa-',
        label: 'Straordinarie dichiarate da società esterna',
        type: 'choice',
        options: [
          {
            value: 'si',
            label: 'Sì',
          },
          {
            value: 'no',
            label: 'No',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Straordinarie dichiarate da società esterna',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_straordinarie-rilevate-da-sistemi-al',
        label: 'Straordinarie rilevate da sistemi allarme',
        type: 'choice',
        options: [
          {
            value: 'si',
            label: 'Sì',
          },
          {
            value: 'no',
            label: 'No',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Straordinarie rilevate da sistemi allarme',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_esito-straordinarie',
        label: 'Esito straordinarie',
        type: 'choice',
        options: [
          {
            value: 'risolto',
            label: 'Risolto',
          },
          {
            value: 'non_risolto',
            label: 'Non risolto',
          },
          {
            value: 'in_corso',
            label: 'In corso',
          },
          {
            value: 'n_a',
            label: 'N/A',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Esito straordinarie',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_dettagli-straordinarie',
        label: 'Dettagli straordinarie',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        placeholder: 'Descrivi interventi eseguiti, componenti, esito',
        _idHistory: {
          derivedFrom: 'Dettagli straordinarie',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
    ],
    rows: [
      {
        id: 'row_unita-refrigerazione',
        label: 'Impianto',
        fieldIds: ['fld_unita-refrigerazione'],
      },
      {
        id: 'row_presenza-fughe',
        label: 'Presenza fughe',
        fieldIds: [
          'fld_fughe-all-atto-del-sopralluogo',
          'fld_fughe-segnalate-nel-periodo',
          'fld_infortuni-dovuti-a-fuga',
        ],
      },
      {
        id: 'row_segnalazioni-fughe',
        label: 'Segnalazioni fughe',
        fieldIds: [
          'fld_dichiarate-dal-personale-patentato',
          'fld_dichiarate-da-societa-esterna',
          'fld_rilevate-da-sistemi-di-allarme',
          'fld_stato-risoluzione',
        ],
      },
      {
        id: 'row_note-fughe',
        label: 'Note fughe',
        fieldIds: ['fld_dettagli-segnalazioni'],
      },
      {
        id: 'row_parametri-di-controllo',
        label: 'Parametri di controllo',
        fieldIds: ['fld_pressione-condensazione', 'fld_temperatura-olio', 'fld_note-parametri'],
      },
      {
        id: 'row_manutenzione-ordinaria',
        label: 'Manutenzione ordinaria',
        fieldIds: ['fld_stato-manutenzione-ordinaria', 'fld_note-manutenzione-ordinaria'],
      },
      {
        id: 'row_manutenzioni-straordinarie',
        label: 'Manutenzioni straordinarie',
        fieldIds: [
          'fld_effettuate-nel-periodo',
          'fld_straordinarie-dichiarate-dal-persona',
          'fld_straordinarie-dichiarate-da-societa-',
          'fld_straordinarie-rilevate-da-sistemi-al',
          'fld_esito-straordinarie',
          'fld_dettagli-straordinarie',
        ],
      },
    ],
    viewBlocks: [],
    navigationGroup: {
      id: 'verifiche-sopralluogo',
      label: 'Verifiche Sopralluogo',
      order: 3,
      icon: 'fact_check',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_verifica-infrastrutture-di-sicurezza',
    name: 'Verifica infrastrutture di sicurezza',
    type: 'static',
    fields: [
      {
        id: 'fld_uscita-di-esodo',
        label: 'Uscita di esodo',
        type: 'choice',
        source: '{{visit.infraVerification.emergencyLightingExit}}',
        options: [
          {
            value: 'sufficiente',
            label: 'Sufficiente',
          },
          {
            value: 'insufficiente',
            label: 'Insufficiente',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Uscita di esodo',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_area-intervento',
        label: 'Area intervento',
        type: 'choice',
        source: '{{visit.infraVerification.emergencyLightingIntervention}}',
        options: [
          {
            value: 'sufficiente',
            label: 'Sufficiente',
          },
          {
            value: 'insufficiente',
            label: 'Insufficiente',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Area intervento',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_note-illuminazione',
        label: 'Note illuminazione',
        type: 'text',
        format: 'multiline',
        source: '{{visit.infraVerification.lightingNotes}}',
        editing: {
          state: 'editable',
        },
        placeholder: 'Annota eventuali apparecchi guasti o zone scoperte',
        _idHistory: {
          derivedFrom: 'Note illuminazione',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_chiusura-porte-accesso',
        label: 'Chiusura porte accesso',
        type: 'choice',
        source: '{{visit.infraVerification.doors}}',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Chiusura porte accesso',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_videosorveglianza',
        label: 'Videosorveglianza',
        type: 'choice',
        source: '{{visit.infraVerification.cctv}}',
        options: [
          {
            value: 'presente',
            label: 'Presente',
          },
          {
            value: 'non_presente',
            label: 'Non presente',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Videosorveglianza',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_allarme-anti-intrusione',
        label: 'Allarme anti intrusione',
        type: 'choice',
        source: '{{visit.infraVerification.intrusion}}',
        options: [
          {
            value: 'presente',
            label: 'Presente',
          },
          {
            value: 'non_presente',
            label: 'Non presente',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Allarme anti intrusione',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_procedure-dvr',
        label: 'Procedure DVR',
        type: 'text',
        format: 'multiline',
        source: '{{visit.infraVerification.dvrProcedures}}',
        editing: {
          state: 'editable',
        },
        placeholder: 'Sintesi aggiornamento DVR e prove di evacuazione',
        _idHistory: {
          derivedFrom: 'Procedure DVR',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_osservazioni-vvf-documenti',
        label: 'Osservazioni VVF/documenti',
        type: 'text',
        format: 'multiline',
        source: '{{visit.infraVerification.safetySuggestions}}',
        editing: {
          state: 'editable',
        },
        placeholder: 'Es. posizione valigetta VVF, documenti mancanti',
        _idHistory: {
          derivedFrom: 'Osservazioni VVF/documenti',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
    ],
    rows: [
      {
        id: 'row_illuminazione-emergenza',
        label: 'Illuminazione emergenza',
        fieldIds: ['fld_uscita-di-esodo', 'fld_area-intervento', 'fld_note-illuminazione'],
      },
      {
        id: 'row_accessi-e-controlli',
        label: 'Accessi e controlli',
        fieldIds: [
          'fld_chiusura-porte-accesso',
          'fld_videosorveglianza',
          'fld_allarme-anti-intrusione',
        ],
      },
      {
        id: 'row_procedure-dvr-e-suggerimenti',
        label: 'Procedure DVR e suggerimenti',
        fieldIds: ['fld_procedure-dvr', 'fld_osservazioni-vvf-documenti'],
      },
    ],
    viewBlocks: [],
    navigationGroup: {
      id: 'verifiche-sopralluogo',
      label: 'Verifiche Sopralluogo',
      order: 3,
      icon: 'fact_check',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_verifica-dpi-riepilogo',
    name: 'Verifica DPI (riepilogo)',
    type: 'static',
    fields: [
      {
        id: 'fld_completezza-dotazione',
        label: 'Completezza dotazione',
        type: 'choice',
        source: '{{visit.dpiInventory.general.completeness}}',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
      },
      {
        id: 'fld_accessibilita-dpi',
        label: 'Accessibilità',
        type: 'choice',
        source: '{{visit.dpiInventory.general.accessibility}}',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
      },
      {
        id: 'fld_stato-conservazione-dpi',
        label: 'Stato conservazione',
        type: 'choice',
        source: '{{visit.dpiInventory.general.condition}}',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
      },
      {
        id: 'fld_chiavi-armadio-presenti',
        label: 'Chiavi armadio presenti',
        type: 'bool',
        source: '{{visit.dpiInventory.general.keysPresent}}',
        formatting: {
          labels: {
            true: 'Sì',
            false: 'No',
          },
        },
        editing: {
          state: 'editable',
        },
      },
      {
        id: 'fld_societa-manutenzione-dpi',
        label: 'Società manutenzione DPI',
        type: 'text',
        source: '{{visit.dpiInventory.general.maintainer}}',
        editing: {
          state: 'editable',
        },
      },
      {
        id: 'fld_note-dpi',
        label: 'Note',
        type: 'text',
        format: 'multiline',
        source: '{{visit.dpiInventory.general.notes}}',
        editing: {
          state: 'editable',
        },
      },
    ],
    rows: [
      {
        id: 'row_dpi-completezza',
        label: 'Dotazione',
        fieldIds: [
          'fld_completezza-dotazione',
          'fld_accessibilita-dpi',
          'fld_stato-conservazione-dpi',
        ],
      },
      {
        id: 'row_dpi-gestione',
        label: 'Gestione',
        fieldIds: ['fld_chiavi-armadio-presenti', 'fld_societa-manutenzione-dpi'],
      },
      {
        id: 'row_dpi-note',
        label: 'Note',
        fieldIds: ['fld_note-dpi'],
      },
    ],
    viewBlocks: [],
    navigationGroup: {
      id: 'verifiche-sopralluogo',
      label: 'Verifiche Sopralluogo',
      order: 3,
      icon: 'fact_check',
    },
    layout: {
      columns: 2,
    },
  },
];

export const CENTRALI_SECTIONS_VERIFICHE: ReportTemplate['sections'] = [
  {
    id: 'sec_verifica-dpi',
    name: 'Verifica DPI — {{unitCheck.unitName}}',
    type: 'repeating',
    repeat: {
      forEach: 'visit.unitChecks',
      as: 'unitCheck',
    },
    fields: [
      {
        id: 'fld_unita-dpi',
        label: 'Impianto',
        type: 'text',
        source: '{{unitCheck.unitName}}',
        _idHistory: {
          derivedFrom: 'Impianto',
          generatedAt: '2026-01-03T00:00:00.000Z',
        },
      },
      {
        id: 'fld_completezza',
        label: 'Completezza',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Completezza',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_accessibilita',
        label: 'Accessibilità',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Accessibilità',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_stato-conservazione',
        label: 'Stato conservazione',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Stato conservazione',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_chiavi-armadio-presenti',
        label: 'Chiavi armadio presenti',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Sì',
            false: 'No',
          },
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Chiavi armadio presenti',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_societa-manutenzione-dpi',
        label: 'Società manutenzione DPI',
        type: 'text',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Società manutenzione DPI',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_stato-conservazione_2',
        label: 'Stato conservazione',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Stato conservazione',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_predisposizione-uso',
        label: 'Predisposizione uso',
        type: 'choice',
        options: [
          {
            value: 'corretta',
            label: 'Corretta',
          },
          {
            value: 'non_corretta',
            label: 'Non corretta',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Predisposizione uso',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_quantita-totale',
        label: 'Quantità totale',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Quantità totale',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_tipologia',
        label: 'Tipologia',
        type: 'choice',
        options: [
          {
            value: 'k1',
            label: 'K1',
          },
          {
            value: 'k2',
            label: 'K2',
          },
          {
            value: 'k3',
            label: 'K3',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Tipologia',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_valenza',
        label: 'Valenza',
        type: 'choice',
        options: [
          {
            value: 'monovalente',
            label: 'Monovalente',
          },
          {
            value: 'polivalente',
            label: 'Polivalente',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Valenza',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_capacita',
        label: 'Capacità',
        type: 'choice',
        options: [
          {
            value: 's',
            label: 'S',
          },
          {
            value: 'm',
            label: 'M',
          },
          {
            value: 'l',
            label: 'L',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Capacità',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_scadenza',
        label: 'Scadenza',
        type: 'date',
        formatting: {
          display: 'month-year',
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Scadenza',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_conformita',
        label: 'Conformità',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Conformità',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_marca-modello',
        label: 'Marca/Modello',
        type: 'text',
        placeholder: 'DIABLO',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Marca/Modello',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_quantita',
        label: 'Quantità',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Quantità',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_litri-bombole',
        label: 'Litri bombole',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Litri bombole',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_pressione-taratura-bar',
        label: 'Pressione taratura (bar)',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Pressione taratura (bar)',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_pressione-rilevata-bar',
        label: 'Pressione rilevata (bar)',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Pressione rilevata (bar)',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_tipo-erogatore',
        label: 'Tipo erogatore',
        type: 'choice',
        options: [
          {
            value: 'monopulsante',
            label: 'Monopulsante',
          },
          {
            value: 'doppio_pulsante',
            label: 'Doppio pulsante',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Tipo erogatore',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_periodicita-revisione-mesi',
        label: 'Periodicità revisione (mesi)',
        type: 'number',
        validation: {
          min: 1,
          max: 24,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Periodicità revisione (mesi)',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_ultimo-controllo',
        label: 'Ultimo controllo',
        type: 'date',
        formatting: {
          display: 'month-year',
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Ultimo controllo',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_prossima-verifica-recipiente',
        label: 'Prossima verifica recipiente',
        type: 'date',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Prossima verifica recipiente',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_stato-conservazione_3',
        label: 'Stato conservazione',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Stato conservazione',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_predisposizione-uso_2',
        label: 'Predisposizione uso',
        type: 'choice',
        options: [
          {
            value: 'corretta',
            label: 'Corretta',
          },
          {
            value: 'non_corretta',
            label: 'Non corretta',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Predisposizione uso',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_tipo',
        label: 'Tipo',
        type: 'choice',
        options: [
          {
            value: 'stagna',
            label: 'Stagna',
          },
          {
            value: 'non_stagna',
            label: 'Non stagna',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Tipo',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_quantita_2',
        label: 'Quantità',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Quantità',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_conformita_2',
        label: 'Conformità',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Conformità',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_guanti-quantita',
        label: 'Guanti - quantità',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Guanti - quantità',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_guanti-conformita',
        label: 'Guanti - conformità',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Guanti - conformità',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_stivali-quantita',
        label: 'Stivali - quantità',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Stivali - quantità',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_stivali-conformita',
        label: 'Stivali - conformità',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Stivali - conformità',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_cassetta-pronto-soccorso',
        label: 'Cassetta pronto soccorso',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_presente',
            label: 'Non presente',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Cassetta pronto soccorso',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_cartellonistica',
        label: 'Cartellonistica',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'integrare',
            label: 'Da integrare',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Cartellonistica',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_integrazioni-cartellonistica',
        label: 'Integrazioni cartellonistica',
        type: 'text',
        placeholder: 'Es. Obbligo uso DPI',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Integrazioni cartellonistica',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_doccia-lavaocchi',
        label: 'Doccia lavaocchi',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Doccia lavaocchi',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
    ],
    rows: [
      {
        id: 'row_unita-dpi',
        label: 'Impianto',
        fieldIds: ['fld_unita-dpi'],
      },
      {
        id: 'row_dotazione-generale',
        label: 'Dotazione generale',
        fieldIds: [
          'fld_completezza',
          'fld_accessibilita',
          'fld_stato-conservazione',
          'fld_chiavi-armadio-presenti',
        ],
      },
      {
        id: 'row_gestione-manutenzione',
        label: 'Gestione manutenzione',
        fieldIds: ['fld_societa-manutenzione-dpi'],
      },
      {
        id: 'row_maschera-filtro-k',
        label: 'Maschera filtro K',
        fieldIds: ['fld_stato-conservazione_2', 'fld_predisposizione-uso'],
      },
      {
        id: 'row_filtri-k',
        label: 'Filtri K',
        fieldIds: [
          'fld_quantita-totale',
          'fld_tipologia',
          'fld_valenza',
          'fld_capacita',
          'fld_scadenza',
        ],
      },
      {
        id: 'row_autorespiratore',
        label: 'Autorespiratore',
        fieldIds: [
          'fld_conformita',
          'fld_marca-modello',
          'fld_quantita',
          'fld_litri-bombole',
          'fld_pressione-taratura-bar',
          'fld_pressione-rilevata-bar',
          'fld_tipo-erogatore',
          'fld_periodicita-revisione-mesi',
          'fld_ultimo-controllo',
          'fld_prossima-verifica-recipiente',
        ],
      },
      {
        id: 'row_maschera-autorespiratore',
        label: 'Maschera autorespiratore',
        fieldIds: ['fld_stato-conservazione_3', 'fld_predisposizione-uso_2'],
      },
      {
        id: 'row_tute-protezione',
        label: 'Tute protezione',
        fieldIds: ['fld_tipo', 'fld_quantita_2', 'fld_conformita_2'],
      },
      {
        id: 'row_guanti-e-stivali',
        label: 'Guanti e stivali',
        fieldIds: [
          'fld_guanti-quantita',
          'fld_guanti-conformita',
          'fld_stivali-quantita',
          'fld_stivali-conformita',
        ],
      },
      {
        id: 'row_altri-dispositivi',
        label: 'Altri dispositivi',
        fieldIds: [
          'fld_cassetta-pronto-soccorso',
          'fld_cartellonistica',
          'fld_integrazioni-cartellonistica',
          'fld_doccia-lavaocchi',
        ],
      },
    ],
    viewBlocks: [],
    navigationGroup: {
      id: 'centrali',
      label: 'Impianti',
      order: 2,
      icon: 'factory',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_verifica-impianto-di-sicurezza',
    name: 'Verifica impianto di sicurezza — {{unitCheck.unitName}}',
    type: 'repeating',
    repeat: {
      forEach: 'visit.unitChecks',
      as: 'unitCheck',
    },
    fields: [
      {
        id: 'fld_unita-sicurezza',
        label: 'Impianto',
        type: 'text',
        source: '{{unitCheck.unitName}}',
        _idHistory: {
          derivedFrom: 'Impianto',
          generatedAt: '2026-01-03T00:00:00.000Z',
        },
      },
      {
        id: 'fld_sensori-per-unita',
        label: 'Sensori per impianto',
        type: 'text',
        format: 'multiline',
        source:
          "{{unitCheck.safety.sensors.status | wrap('Stato: ', '')}}{{unitCheck.safety.sensors.lastCalibration | wrap(' · Ultima taratura: ', '')}}{{unitCheck.safety.sensors.periodicityMonths | wrap(' · Periodicità: ', ' mesi')}}{{unitCheck.safety.sensors.lastElementReplacement | wrap(' · Ultima sostituzione elementi: ', '')}}{{unitCheck.safety.sensors.replacementSchedule | wrap(' · Sostituzione programmata: ', '')}}{{unitCheck.safety.sensors.maintainer | wrap(' · Manutentore: ', '')}}",
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Sensori per impianto',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_valvole-per-unita',
        label: 'Valvole per impianto',
        type: 'text',
        format: 'multiline',
        source:
          "{{unitCheck.safety.reliefValves.setpoint | wrap('Pressione: ', ' bar')}}{{unitCheck.safety.reliefValves.nextDue | wrap(' · Scadenza: ', '')}}{{unitCheck.safety.reliefValves.periodYears | wrap(' · Periodicità: ', ' anni')}}",
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Valvole per impianto',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_configurazione-valvole',
        label: 'Configurazione valvole',
        type: 'text',
        format: 'multiline',
        source:
          "{{unitCheck.safety.shutoffValves.type | wrap('Tipo: ', '')}}{{unitCheck.safety.shutoffValves.sealedON | bool('Sì','No','N/D') | wrap(' · Piombate ON: ', '')}}{{unitCheck.safety.shutoffValves.sealedNonON | bool('Sì','No','N/D') | wrap(' · Piombate NON ON: ', '')}}{{unitCheck.safety.shutoffValves.integrity | wrap(' · Integrità: ', '')}}",
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Configurazione valvole',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_estrattori',
        label: 'Estrattori',
        type: 'text',
        format: 'multiline',
        source:
          "{{unitCheck.safety.extractors.selectorState | wrap('Selettore: ', '')}}{{unitCheck.safety.extractors.testRun | bool('Eseguita','Non eseguita','N/D') | wrap(' · Prova attivazione: ', '')}}{{unitCheck.safety.extractors.activationMethod | wrap(' · Metodo: ', '')}}",
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Estrattori',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_scrubber',
        label: 'Scrubber',
        type: 'text',
        format: 'multiline',
        source:
          "{{unitCheck.safety.scrubber.extractorSelector | wrap('Estrattore: ', '')}}{{unitCheck.safety.scrubber.extractorTest | bool('Test ok','Test non eseguito','N/D') | wrap(' · Prova estrattore: ', '')}}{{unitCheck.safety.scrubber.pumpSelector | wrap(' · Pompa: ', '')}}{{unitCheck.safety.scrubber.pumpTest | bool('Test ok','Test non eseguito','N/D') | wrap(' · Prova pompa: ', '')}}",
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Scrubber',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_controlli-abbattimento',
        label: 'Controlli abbattimento',
        type: 'text',
        format: 'multiline',
        source:
          "{{unitCheck.safety.abatementSystem.selectorState | wrap('Selettore: ', '')}}{{unitCheck.safety.abatementSystem.testRun | bool('Sì','No','N/D') | wrap(' · Prova: ', '')}}{{unitCheck.safety.abatementSystem.activationMethod | wrap(' · Metodo: ', '')}}{{unitCheck.safety.abatementSystem.trim | wrap(' · Trim: ', '')}}{{unitCheck.safety.abatementSystem.notes | wrap(' · Note: ', '')}}",
        editing: {
          state: 'editable',
        },
        placeholder: 'Selettore: auto · Prova: Sì',
        _idHistory: {
          derivedFrom: 'Controlli abbattimento',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_sgancio-ee',
        label: 'Sgancio EE',
        type: 'text',
        format: 'multiline',
        source:
          "{{unitCheck.safety.emergencyShutoff.button | wrap('Pulsante: ', '')}}{{unitCheck.safety.emergencyShutoff.detectors | wrap(' · Rilevatori: ', '')}}{{unitCheck.safety.emergencyShutoff.trim | wrap(' · Trim: ', '')}}",
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Sgancio EE',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_centralina-allarmi',
        label: 'Centralina allarmi',
        type: 'text',
        format: 'multiline',
        source:
          "{{unitCheck.safety.alarmPanel.state | wrap('Stato: ', '')}}{{unitCheck.safety.alarmPanel.history | wrap(' · Storico: ', '')}}{{unitCheck.safety.alarmPanel.detectorsDisabled | bool('Sì','No','N/D') | wrap(' · Rilevatori esclusi: ', '')}}{{unitCheck.safety.alarmPanel.otherIssues | bool('Sì','No','N/D') | wrap(' · Altre anomalie: ', '')}}{{unitCheck.safety.alarmPanel.issueDetails | wrap(' · Note: ', '')}}",
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Centralina allarmi',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_combinatore-guardiania',
        label: 'Combinatore / Guardiania',
        type: 'text',
        format: 'multiline',
        source:
          "{{unitCheck.safety.dialer.state | wrap('Combinatore: ', '')}}{{unitCheck.safety.dialer.contacts | wrap(' · Contatti: ', '')}}",
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Combinatore / Guardiania',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_conducibilita-acqua-condensatori',
        label: 'Conducibilità acqua condensatori',
        type: 'text',
        format: 'multiline',
        source:
          "{{unitCheck.safety.condenserWaterConductivity | wrap('', ' µS')}}{{unitCheck.safety.conductivityNotes | wrap(' · Note: ', '')}}",
        editing: {
          state: 'editable',
        },
        placeholder: '45 µS · Note',
        _idHistory: {
          derivedFrom: 'Conducibilità acqua condensatori',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_dispositivi-di-allarme',
        label: 'Dispositivi di allarme',
        type: 'text',
        format: 'multiline',
        source:
          "{{unitCheck.safety.alarmButton | wrap('Pulsante allarme: ', '')}}{{unitCheck.safety.audioVisualAlarm | wrap(' · Segnalatore ottico/acustico: ', '')}}",
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Dispositivi di allarme',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_vie-d-esodo-e-valvole',
        label: "Vie d'esodo e valvole",
        type: 'text',
        format: 'multiline',
        source:
          "{{unitCheck.safety.exitRoutes | wrap('Vie di esodo: ', '')}}{{unitCheck.safety.valveControls | wrap(' · Integrità valvole: ', '')}}{{unitCheck.safety.notes | wrap(' · Note: ', '')}}",
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: "Vie d'esodo e valvole",
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
    ],
    rows: [
      {
        id: 'row_unita-sicurezza',
        label: 'Impianto',
        fieldIds: ['fld_unita-sicurezza'],
      },
      {
        id: 'row_sensori-rilevazione-nh',
        label: 'Sensori rilevazione NH₃',
        fieldIds: ['fld_sensori-per-unita'],
      },
      {
        id: 'row_valvole-di-sicurezza',
        label: 'Valvole di sicurezza',
        fieldIds: ['fld_valvole-per-unita'],
      },
      {
        id: 'row_valvole-intercettazione',
        label: 'Valvole intercettazione',
        fieldIds: ['fld_configurazione-valvole'],
      },
      {
        id: 'row_sistemi-di-estrazione-scrubber',
        label: 'Sistemi di estrazione / scrubber',
        fieldIds: ['fld_estrattori', 'fld_scrubber'],
      },
      {
        id: 'row_sistema-di-abbattimento',
        label: 'Sistema di abbattimento',
        fieldIds: ['fld_controlli-abbattimento'],
      },
      {
        id: 'row_sgancio-elettrico-e-allarmi',
        label: 'Sgancio elettrico e allarmi',
        fieldIds: ['fld_sgancio-ee', 'fld_centralina-allarmi'],
      },
      {
        id: 'row_comunicazioni-e-condensa',
        label: 'Comunicazioni e condensa',
        fieldIds: ['fld_combinatore-guardiania', 'fld_conducibilita-acqua-condensatori'],
      },
      {
        id: 'row_segnalazioni-e-vie-di-esodo',
        label: 'Segnalazioni e vie di esodo',
        fieldIds: ['fld_dispositivi-di-allarme', 'fld_vie-d-esodo-e-valvole'],
      },
    ],
    viewBlocks: [],
    navigationGroup: {
      id: 'centrali',
      label: 'Impianti',
      order: 2,
      icon: 'factory',
    },
    layout: {
      columns: 2,
    },
  },
];

export const CENTRALI_SECTIONS_EMERGENZA: ReportTemplate['sections'] = [
  {
    id: 'sec_prova-di-emergenza',
    name: 'Prova di emergenza — {{unit.name}}',
    type: 'repeating',
    repeat: {
      forEach: 'site.refrigerationUnits',
      as: 'unit',
    },
    fields: [
      {
        id: 'fld_responsabili',
        label: 'Responsabili',
        type: 'text',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Responsabili',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_verifica',
        label: 'Verifica',
        type: 'choice',
        options: [
          {
            value: 'parziale',
            label: 'Parziale',
          },
          {
            value: 'completa',
            label: 'Completa',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Verifica',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_conformita-prova',
        label: 'Conformità prova',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Conformità prova',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_inizio',
        label: 'Inizio',
        type: 'text',
        placeholder: 'HH:MM',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Inizio',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_fine',
        label: 'Fine',
        type: 'text',
        placeholder: 'HH:MM',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Fine',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_ultima-verifica-completa',
        label: 'Ultima verifica completa',
        type: 'date',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Ultima verifica completa',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_frequenza',
        label: 'Frequenza',
        type: 'text',
        placeholder: 'annuale',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Frequenza',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_metodo-esecuzione',
        label: 'Metodo esecuzione',
        type: 'choice',
        options: [
          {
            value: 'bombola_nh3',
            label: 'Kit con bombola Ammoniaca',
          },
          {
            value: 'ampolle',
            label: 'Ampolle calibrate',
          },
          {
            value: 'soluzione',
            label: 'Soluzione ammoniacale',
          },
          {
            value: 'altro',
            label: 'Altro',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Metodo esecuzione',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
    ],
    rows: [],
    viewBlocks: [],
    navigationGroup: {
      id: 'centrali',
      label: 'Impianti',
      order: 2,
      icon: 'factory',
    },
    layout: {
      columns: 2,
    },
  },
];

export const VERIFICHE_SECTIONS_SECONDARY: ReportTemplate['sections'] = [
  {
    id: 'sec_registri',
    name: 'Registri',
    type: 'static',
    fields: [
      {
        id: 'fld_stato-registri-manutenzione',
        label: 'Stato registri manutenzione',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Stato registri manutenzione',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_note-registri-manutenzione',
        label: 'Note registri manutenzione',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        placeholder: "Annotazioni sull'esito dei registri manutenzione",
        _idHistory: {
          derivedFrom: 'Note registri manutenzione',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_stato-registri-di-sicurezza',
        label: 'Stato registri di sicurezza',
        type: 'choice',
        options: [
          {
            value: 'conforme',
            label: 'Conforme',
          },
          {
            value: 'non_conforme',
            label: 'Non conforme',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Stato registri di sicurezza',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_note-registri-di-sicurezza',
        label: 'Note registri di sicurezza',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        placeholder: 'Annotazioni sui registri di sicurezza',
        _idHistory: {
          derivedFrom: 'Note registri di sicurezza',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_registrato-carico',
        label: 'Registrato carico',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Sì',
            false: 'No',
          },
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Registrato carico',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_quantita-carico-kg',
        label: 'Quantità carico (kg)',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Quantità carico (kg)',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_registrato-scarico',
        label: 'Registrato scarico',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Sì',
            false: 'No',
          },
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Registrato scarico',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_quantita-scarico-kg',
        label: 'Quantità scarico (kg)',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Quantità scarico (kg)',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_registro-inalterato',
        label: 'Registro inalterato',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Sì',
            false: 'No',
          },
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Registro inalterato',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_quantita-registrata-totale-kg',
        label: 'Quantità registrata totale (kg)',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Quantità registrata totale (kg)',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_note-registro-carico-scarico',
        label: 'Note registro carico/scarico',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        placeholder: 'Annotazioni aggiuntive sul registro carico/scarico',
        _idHistory: {
          derivedFrom: 'Note registro carico/scarico',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
    ],
    rows: [
      {
        id: 'row_registri-manutenzione',
        label: 'Registri manutenzione',
        fieldIds: ['fld_stato-registri-manutenzione', 'fld_note-registri-manutenzione'],
      },
      {
        id: 'row_registri-di-sicurezza',
        label: 'Registri di sicurezza',
        fieldIds: ['fld_stato-registri-di-sicurezza', 'fld_note-registri-di-sicurezza'],
      },
      {
        id: 'row_registro-carico-scarico',
        label: 'Registro carico/scarico',
        fieldIds: [
          'fld_registrato-carico',
          'fld_quantita-carico-kg',
          'fld_registrato-scarico',
          'fld_quantita-scarico-kg',
          'fld_registro-inalterato',
          'fld_quantita-registrata-totale-kg',
          'fld_note-registro-carico-scarico',
        ],
      },
    ],
    viewBlocks: [],
    navigationGroup: {
      id: 'verifiche-sopralluogo',
      label: 'Verifiche Sopralluogo',
      order: 3,
      icon: 'fact_check',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_verifica-aggiornamento-formazione',
    name: 'Verifica aggiornamento formazione',
    type: 'static',
    fields: [
      {
        id: 'fld_eseguito',
        label: 'Eseguito',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Eseguito',
            false: 'Non eseguito',
          },
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Eseguito',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_prevista-in-data',
        label: 'Prevista in data',
        type: 'date',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Prevista in data',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_conoscenza-pericoli',
        label: 'Conoscenza pericoli',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Conforme',
            false: 'Non conforme',
          },
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Conoscenza pericoli',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_conoscenza-procedure',
        label: 'Conoscenza procedure',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Conforme',
            false: 'Non conforme',
          },
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Conoscenza procedure',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_approfondimenti-informativi',
        label: 'Approfondimenti informativi',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Eseguiti',
            false: 'Non eseguiti',
          },
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Approfondimenti informativi',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_aggiornamento-dvr',
        label: 'Aggiornamento DVR',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Aggiornato',
            false: 'Da aggiornare',
          },
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Aggiornamento DVR',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_aggiornamento-dpi',
        label: 'Aggiornamento DPI',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Eseguito',
            false: 'Non eseguito',
          },
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Aggiornamento DPI',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
    ],
    rows: [],
    viewBlocks: [],
    navigationGroup: {
      id: 'verifiche-sopralluogo',
      label: 'Verifiche Sopralluogo',
      order: 3,
      icon: 'fact_check',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_partecipanti-corso',
    name: 'Partecipanti corso',
    type: 'repeating',
    repeat: {
      forEach: 'visit.trainingVerification.participants',
      as: 'pc',
    },
    fields: [
      {
        id: 'fld_firma',
        label: 'Firma',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Firmato',
            false: 'Non firmato',
          },
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Firma',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
    ],
    rows: [],
    viewBlocks: [],
    navigationGroup: {
      id: 'verifiche-sopralluogo',
      label: 'Verifiche Sopralluogo',
      order: 3,
      icon: 'fact_check',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_verifica-utilizzo-dpi-iii-categoria-',
    name: 'Verifica utilizzo DPI III categoria',
    type: 'static',
    fields: [
      {
        id: 'fld_tempo-preparazione-min',
        label: 'Tempo preparazione (min)',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Tempo preparazione (min)',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_tempo-intervento-min',
        label: 'Tempo intervento (min)',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Tempo intervento (min)',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_pressione-iniziale-bar',
        label: 'Pressione iniziale (bar)',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Pressione iniziale (bar)',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_pressione-finale-bar',
        label: 'Pressione finale (bar)',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Pressione finale (bar)',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_consumo-l-min',
        label: 'Consumo (l/min)',
        type: 'number',
        validation: {
          min: 0,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Consumo (l/min)',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_conforme',
        label: 'Conforme',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Conforme',
            false: 'Non conforme',
          },
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Conforme',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_tratti-impianto',
        label: 'Tratti impianto',
        type: 'text',
        format: 'multiline',
        hint: 'Es. Valvola Alta Pressione Compressore',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Tratti impianto',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_posizione',
        label: 'Posizione',
        type: 'choice',
        options: [
          {
            value: 'piano_terra',
            label: 'Piano terra',
          },
          {
            value: 'piano_primo',
            label: 'Piano primo',
          },
          {
            value: 'copertura',
            label: 'Copertura',
          },
          {
            value: 'altro',
            label: 'Altro',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Posizione',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_necessario-affrontare-scale',
        label: 'Necessario affrontare scale',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Sì',
            false: 'No',
          },
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Necessario affrontare scale',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_modalita-esecuzione',
        label: 'Modalità esecuzione',
        type: 'text',
        format: 'multiline',
        placeholder: 'Partenza da postazione DPI',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Modalità esecuzione',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_difficolta-riscontrate',
        label: 'Difficoltà riscontrate',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Difficoltà riscontrate',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
    ],
    rows: [],
    viewBlocks: [],
    navigationGroup: {
      id: 'verifiche-sopralluogo',
      label: 'Verifiche Sopralluogo',
      order: 3,
      icon: 'fact_check',
    },
    layout: {
      columns: 2,
    },
  },
];

export const VERIFICHE_SECTIONS_FINAL: ReportTemplate['sections'] = [
  {
    id: 'sec_inail',
    name: 'INAIL',
    type: 'static',
    fields: [
      {
        id: 'fld_tipologia-attrezzatura',
        label: 'Tipologia attrezzatura',
        type: 'choice',
        source: '{{visit.inailCompliance.equipmentType}}',
        options: [
          {
            value: 'insieme_ui',
            label: 'Insieme UI',
          },
          {
            value: 'insieme_non_ui',
            label: 'Insieme non UI',
          },
          {
            value: 'non_insieme_ce',
            label: 'Non insieme CE',
          },
        ],
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Tipologia attrezzatura',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_ispesl-ante-ped',
        label: 'ISPESL ante PED',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Sì',
            false: 'No',
          },
        },
        source: '{{visit.inailCompliance.ispeslAntePed}}',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'ISPESL ante PED',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_impianto-immatricolato',
        label: 'Impianto immatricolato',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Sì',
            false: 'No',
          },
        },
        source: '{{visit.inailCompliance.registered}}',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Impianto immatricolato',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_verifica-periodica-funzionamento',
        label: 'Verifica periodica - funzionamento',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Eseguita',
            false: 'Non eseguita',
          },
        },
        source: '{{visit.inailCompliance.periodicInspection.function}}',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Verifica periodica - funzionamento',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_verifica-periodica-integrita',
        label: 'Verifica periodica - integrità',
        type: 'bool',
        formatting: {
          labels: {
            true: 'Eseguita',
            false: 'Non eseguita',
          },
        },
        source: '{{visit.inailCompliance.periodicInspection.integrity}}',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Verifica periodica - integrità',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_note-inail',
        label: 'Note INAIL',
        type: 'text',
        format: 'multiline',
        source: '{{visit.inailCompliance.notes}}',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Note INAIL',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
    ],
    rows: [],
    viewBlocks: [],
    navigationGroup: {
      id: 'verifiche-sopralluogo',
      label: 'Verifiche Sopralluogo',
      order: 3,
      icon: 'fact_check',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_note-generali',
    name: 'Note generali',
    type: 'static',
    fields: [
      {
        id: 'fld_note-generali',
        label: 'Note generali',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Note generali',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
    ],
    rows: [],
    viewBlocks: [],
    navigationGroup: {
      id: 'verifiche-sopralluogo',
      label: 'Verifiche Sopralluogo',
      order: 3,
      icon: 'fact_check',
    },
  },
];
